import React, { PureComponent } from 'react';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';


import * as constants from '../constants';

import { RatingFormSchema } from '../validation';

const mapStateToProps = state => ({
  global: state.Global
});

const modelOpenText = 'modal-open';

export const hideActiveModal = (props) => {
  let { onClose } = props;
  const modal = document.getElementsByClassName('modal show')[0];
  const fade = document.getElementsByClassName('modal-backdrop show')[0];
  const modalOpen = document.getElementsByClassName(modelOpenText)[0];
  if (modal) {
    modal.className = modal.className.replace('show', '');
    modal.style = "display: none;";
  }
  if (fade) {
    fade.className = fade.className.replace('show', '');
    fade.className = fade.className.replace('modal-backdrop', '');
  }
  if (modalOpen) {
    modalOpen.className = modalOpen.className.replace(modelOpenText, '');
  }
  onClose();
}

export const openActiveModal = (id) => {
  const modal = document.getElementById(id);
  const body = document.body;
  const fade = document.createElement("div");
  fade.className = "modal-backdrop show"
  modal.className = modal.className.concat(' show');
  modal.style = "display: block;";
  body.className = body.className.concat(` ${modelOpenText}`);
  body.appendChild(fade);
}


class RatingForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        reviewingUser: props.global.userId ? props.global.userId : '',
        values: props.values.type === "listing" ? [0, 0, 0, 0] : [0, 0, 0],
        message: '',
        type: props.values.type,
        id: props.values.id
      }
    }

    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    openActiveModal('ratingModal');
  }
  componentWillUnmount() {
    hideActiveModal(this.props);
  }

  submitForm(values, { resetForm }) {
    let { onSubmit } = this.props;
    onSubmit(values);
    resetForm(this.state.initialValues);
  }

  renderStars(form, field) {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(<i key={`${field.name}_${i}`} onClick={() => form.setFieldValue(field.name, i)} className={(i <= field.value ? "fas" : "far") + " fa-star"} />)
    }
    return (<div className="col">{stars}</div>)
  }

  render() {
    let { values } = this.props;
    let descriptions = values.type === 'listing'
      ? constants.REVIEW_LISTING_TYPES
      : constants.REVIEW_USER_TYPES;
    let { initialValues } = this.state;
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={this.submitForm}
        validationSchema={RatingFormSchema}>
        {({ resetForm, errors }) => (
          <Form>
            <div className="modal" id="ratingModal" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{values.title}</h5>
                  </div>
                  <div className="modal-body">
                    {errors && errors.values && (<div className="error-message w-100 pl-3">All ratings must have a value.</div>)}
                    <div className="w-100">
                      {descriptions.map((d, i) => {
                        return (
                          <Field key={`rating_${i}`} name={`values[${i}]`}>
                            {({ field, form }) => (
                              <div className="row mt-3 mb-4">
                                <div className="col">
                                  <strong>{d}</strong>
                                </div>
                                {this.renderStars(form, field)}
                              </div>
                            )}</Field>
                        )
                      })}

                      <h5>Are there any additional comments you would like to make? (Optional)</h5>
                      <div className="w-100">
                        <Field
                          name="message"
                          component="textarea"
                          className="form-control mt-3 mb-3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <label onClick={() => {
                      resetForm(initialValues);
                      hideActiveModal(this.props);
                    }}>Cancel</label>
                    <button className="btn btn-primary" type="submit">Submit</button>
                  </div>
                </div>
              </div></div></Form>
        )}</Formik>
    )
  }
}

export default connect(mapStateToProps)(RatingForm);
